import { getConfig } from "../config";


export class HttpApiClient {

  constructor(
    config
  ) {
    this.baseUrl = config.baseUrl;
    this.headers = config.headers;
    this.onBeforeRequest = config.onBeforeRequest
  }

  async get(resource, params) {
    await this.onBeforeRequest()
    return this._sendWithoutBody('GET', resource, params);
  }

  async post(resource, data) {
    await this.onBeforeRequest()
    return this._sendWithBody('POST', resource, data);
  }

  async put(resource, data) {
    await this.onBeforeRequest()
    return this._sendWithBody('PUT', resource, data);
  }

  async patch(resource, data) {
    await this.onBeforeRequest()
    return this._sendWithBody('PATCH', resource, data);
  }

  async delete(resource, data) {
    await this.onBeforeRequest()
    return this._sendWithBody('DELETE', resource, data);
  }

  async _sendWithoutBody(method, resource, params) {
    const url = this._makeUrl(
      this.baseUrl,
      resource,
      params ?? {}
    );

    const response = await fetch(
      url,
      {
        method: method,
        headers: {
          'Content-Type': 'application/json',
          ...(this._getAuthHeaders()),
          ...(this._getDbgHeaders())
        }
      }
    );

    return this.handleResponse(response);
  }

  async _sendWithBody(method, resource, data) {
    const url = this._makeUrl(
      this.baseUrl,
      resource
    );

    const response = await fetch(
      url,
      {
        method: method,
        headers: {
          ContentType: 'application/json',
          ...(this._getAuthHeaders()),
          ...(this._getDbgHeaders())
        },
        body: JSON.stringify(data)
      }
    );

    return this.handleResponse(response);
  }

  _makeUrl(base, pathWithoutLeadingSlash, params) {

    // remove for trailing slash that shouldn't be there
    if (base.endsWith("/")) {
      base.replace(/\/$/, '');
    }

    const url = new URL([base, pathWithoutLeadingSlash].join('/'));
    Object.entries(params ?? {}).forEach(([k, v]) => url.searchParams.append(k, v));
    return url;
  }

  _getAuthHeaders() {
    const user = JSON.parse(localStorage.getItem(getConfig("userLocalStorage")));
    
    return user
      ? {
          AccessToken: user?.AccessToken,
          IdToken: user?.IdToken,
          RefreshToken: user?.RefreshToken
        }
      : { }
    ;
  }

  _getDbgHeaders() {
    const dbg = localStorage.getItem(getConfig('apiDbgToken'));
    return dbg ? { dbg } : {};
  }

  /**
   * @argument {Response} response
   */
  async handleResponse(response) {
    if (response.ok) {
      if (response.headers.get("Content-Type") == 'application/json')
        return await response.json();
    }

    else
      throw await response.text();
  }
}
